<template>
  <layout-no-menu>
    <ion-content></ion-content>
  </layout-no-menu>
</template>

<script>
// The cart and the pay page were merged into Pay.vue. This route stays for old links (SignUp, bookmarks).
export default {
  name: "Payment",
  created() {
    this.$router.replace({ name: "Pay", params: { tournament: this.$route.params.tournament }, query: this.$route.query });
  },
};
</script>
